<template>
<el-descriptions direction="horizontal" :column="6" border>
     <el-descriptions-item label="婚庆套餐价">{{wedding.wedding_package_price}}</el-descriptions-item>
    <el-descriptions-item label="婚礼执行公司">{{order.wedding_company}}</el-descriptions-item>
    <el-descriptions-item label="订单状态"><el-tag type="danger">{{order.item_check_status}}</el-tag></el-descriptions-item>
    <template v-if="order.user"><el-descriptions-item label="订单销售">{{order.user.realname}}</el-descriptions-item></template>
    <el-descriptions-item label="策划师">
        <template v-for="(item,index) in order.planner">
            <el-tag :key="index">{{item.realname}}</el-tag>
        </template>
    </el-descriptions-item>
    <el-descriptions-item label="酒店名称">{{order.hotel}}</el-descriptions-item>
    <el-descriptions-item label="宴会厅">{{order.hall}}</el-descriptions-item>
    <el-descriptions-item label="宴会类型">
        <template v-for="(item,index) in order.banquet_type">
            <el-tag :key="index" v-if="item==1">午宴</el-tag>
            <el-tag :key="index" v-if="item==2">晚宴</el-tag>
        </template>
    </el-descriptions-item>
    <el-descriptions-item label="客户姓名">{{order.bridegroom}}/{{order.bride}}</el-descriptions-item>
    <el-descriptions-item label="举办时间">
      {{order.event_date}}
          <template v-if="delayList.length>0">
                <el-tag  class="tag" @click="showDrawerPass(_self, 'delayWeddingList', 'showDialog', ['delay',delayList])" type="warning">延期列表</el-tag>
      </template>
      </el-descriptions-item>
</el-descriptions>
</template>

<script>
export default {
    props: {
        order: {
            user: {},
            planner: {}
        },
        wedding:{}
    },
    data() {
        return {};
    }
}
</script>
